export default __webpack_public_path__ + "src/images/packages/shipwreck-lodge/e246ddcf52ef7586e2f56e772aed3216-1.png";